export default __webpack_public_path__ + "static/media/4db57973c19fe49536a7a1c3e1963977.jpg";